var angular = require('angular');
// var d3 = require('d3');
var tpl = require('./component.html');
var utils = require('amt_admin/utils');
var content_generator = require('./tooltip_content_generator').default;

var amt_chart = {
    template: tpl,
    bindings: {
        name: '@',
        chartOptions: '<',
        params: '<',
        cdata: '<',
        forcedOptions: '<'
    },
    controller: ['jsonrpc', '$uibModal', function (jsonrpc, $uibModal) {
        this.display = false;
        this.options = undefined;
        this.use_component_data = this.cdata !== undefined;
        this.data = undefined;
        this.csv_data = undefined;
        this.sql_query = undefined;

        this.setup_options = function (options) {
            if (options.chart.xAxis.tickFormatType === 'date') {
                options.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format(options.chart.xAxis.tickFormatParam)(new Date(d))
                }
            }
            options.chart.interactiveLayer = {};
            options.chart.interactiveLayer.tooltip = {};
            options.chart.interactiveLayer.tooltip.contentGenerator = function(d, elem) {
                return content_generator(d, elem, true);
            };
            self.options = options;
        };

        var self = this;


        var api_service = this.name.split('.')[0];
        var api_method = this.name.split('.')[1];
        var charts_api = jsonrpc.newService(api_service).createMethod(api_method);

        const build_csv_data = function(data) {
            const csv_headers = ',' + data.map(x => `"${x.key}"`).join(',');
            if (data.length == 0) {
                return csv_headers;
            }
            const csv_rows = [csv_headers];
            for (let i = 0; i < data[0].values.length; i++) {
                const first = utils.transform_to_date_if_timestamp(data[0].values[i].x);
                const row = [first];
                for (let item of data) {
                    row.push(item.values[i] !== undefined ? item.values[i].y : '');
                }
                csv_rows.push(row.join(','));
            }
            return csv_rows.join('\n');
        };

        var set_chart_data = function(data) {
            self.data = data;
            self.display = true;
            self.csv_data = build_csv_data(data);
            if (self.nvd3_chart) {
                self.nvd3_chart.updateWithData(data);
            }
        };
        var set_sql_query = function(query) {
            self.sql_query = query.trim();
        }

        this.download_chart_csv = function(name) {
            utils.download_csv_file(name, self.csv_data);
        };

        this.open_sql_modal = function() {
            var modalInstance = $uibModal.open({
                ariaDescribedBy: 'modal-body',
                templateUrl: 'sql_modal.html',
                controller: ['clipboard', function(clipboard) {
                    this.sql_query = self.sql_query;
                    this.close = function () {
                        modalInstance.dismiss();
                    };
                    this.copy_sql_query = function() {
                        clipboard.copyText(self.sql_query.trim());
                    };
                }],
                controllerAs: '$ctrl',
                size: 'md',
            });
        };

        this.$onInit = function () {
            if (!this.use_component_data) {
                charts_api({
                    action: 'get',
                    params: this.params || {}
                })
                .then(function (resp) {
                    resp.options['chart'] = angular.extend(resp.options['chart'], self.chartOptions);
                    self.setup_options(resp.options);
                    set_chart_data(resp.data);
                    set_sql_query(resp.query);
                })
            } else if (!self.forcedOptions){
                charts_api({
                    action: 'get_options',
                    params: this.params || {}
                })
                .then(function (resp) {
                    resp['chart'] = angular.extend(resp['chart'], self.chartOptions);
                    self.setup_options(resp);
                    set_chart_data(self.cdata);
                })
            } else {
                self.setup_options(self.forcedOptions);
                set_chart_data(self.cdata);
            }
        };
        this.$onChanges = function (changesObj) {
            if (changesObj.params && !changesObj.params.isFirstChange() && !this.use_component_data) {
                charts_api({
                    action: 'get',
                    params: this.params
                })
                    .then(function (resp) {
                        set_chart_data(resp.data);
                        set_sql_query(resp.query);
                    })
            }
            else if(changesObj.cdata && !changesObj.cdata.isFirstChange()){
                set_chart_data(changesObj.cdata.currentValue);
            }
        }
    }]
};

export default function (app) {
    app.component('amtChart', amt_chart)
};
